import React from "react";
import bg_image from "../../assets/images/Gallery Page Header-01.jpg";
import bg_image_M from "../../assets/images/Gallery Page Header Mobile screen-01.jpg";

const GalleryBanner = () => {
  return (
    <div className=" w-full xl:bg-fixed relative mx-auto   overflow-hidden flex items-center justify-center">
      {/* Content */}
      <div className="w-full">
        <img src={bg_image} alt="" className="w-full  h-auto hidden xl:block " />
        <img src={bg_image_M} alt="" className="w-full   block xl:hidden " />
      </div>
    </div>
  );
};
export default GalleryBanner;


